// src/components/UpdateBar.jsx
// 3.62.30: the small bar for a new version that couldn't load by itself (see
// utils/appUpdate.js): shown after 10 minutes without a safe moment, or when
// the automatic reload didn't bring the new version. Refresh loads it now.
import { useEffect, useState } from 'react';
import { showUpdateBar, onUpdateChange, refreshNow } from '../utils/appUpdate';
import { PHONE_MEDIA } from '../hooks/useWindowWidth';
import { BAR_HEIGHT } from './BottomBar';

export default function UpdateBar() {
  const [show, setShow] = useState(showUpdateBar);
  useEffect(() => {
    const again = () => setShow(showUpdateBar());
    const t = setInterval(again, 30 * 1000);
    const off = onUpdateChange(again);
    return () => { clearInterval(t); off(); };
  }, []);
  if (!show) return null;
  return (
    <div className="update-bar" role="status" aria-live="polite" style={S.bar}>
      <style>{CSS}</style>
      <span>A new version of the Fax Portal is ready.</span>
      <button type="button" onClick={refreshNow} style={S.btn}>Refresh</button>
    </div>
  );
}

const CSS = `
.update-bar { bottom: calc(18px + env(safe-area-inset-bottom, 0px)); }
@media ${PHONE_MEDIA} { .update-bar { bottom: calc(${BAR_HEIGHT + 12}px + env(safe-area-inset-bottom, 0px)); } }
`;

const S = {
  bar: {
    position: 'fixed', left: 16, right: 16, margin: '0 auto', width: 'fit-content', zIndex: 2500,
    display: 'flex', alignItems: 'center', gap: 12,
    padding: '8px 8px 8px 16px', borderRadius: 999, fontSize: 14, fontWeight: 600,
    background: 'var(--c-263238)', color: 'var(--t-ffffff)', boxShadow: '0 8px 24px rgb(var(--c-000000-rgb) / 0.25)',
  },
  btn: {
    border: 'none', borderRadius: 999, padding: '6px 14px', fontSize: 14, fontWeight: 700, cursor: 'pointer', flexShrink: 0,
    background: 'var(--c-00897b)', color: 'var(--t-ffffff)',
  },
};
